module.exports = __webpack_public_path__ + "static/img/VIP.ca4123b9.png";